var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "panel",
        on: {
          click: function($event) {
            $event.stopPropagation()
          }
        }
      },
      [
        _vm._t("image"),
        _vm._v(" "),
        _c("button", {
          staticClass: "close",
          attrs: { type: "button", "aria-label": "閉じる" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }